/*
 * The application's browser history, in a module of its own.
 *
 * WHY IT IS NOT IN `index.js` ANY MORE. `index.js` is the entry point: importing it calls
 * `ReactDOM.render` and boots the whole application. It also exported `history`, and three leaf
 * components imported it from there — so importing `BackButton`, transitively, STARTED THE APP.
 *
 * In the browser that is invisible: the bundler loads `index.js` first, so the later import
 * resolves to a module that has already run. Under a test runner the test file is the entry, so
 * `index.js` runs fresh and mounts the application while a test is merely trying to import a
 * button. That is why `App.test.js` could never be repaired by fixing one import at a time.
 *
 * Behaviour is unchanged: ES modules are singletons, so `createBrowserHistory()` runs exactly
 * once either way, and every consumer receives the same object it did before.
 */
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export default history;
